import {
  NetActivity,
  NetActivityNew,
  NetFront,
  NetPromoItem,
  NetReward,
} from "@/constants/netEvent";
import { reqGet, reqPost } from "@/service/clientRequest";
import { setAllOpenActivity } from "@/stores/activityStore";
import { updateDetailsData } from "@/stores/bonusCenterStore";
import {
  ActiveRsp,
  ActivityReq,
  GetAgentDetailsReq,
  GetAgentDetailsRsp,
  GetAllAgentConfigReq,
  GetAllAgentConfigRsp,
  GetAllRepeatConfigRsp,
  GetDetailsV2Req,
  GetDetailsV2Rsp,
  GetLuckyTurnTableActivityDataResq,
  GetRepeatConfigsByAtypeReq,
  GetRepeatConfigsByAtypeResp,
  GetRepeatDetailsByAtypeReq,
  GetRepeatDetailsByAtypeRsp,
  GetRepeatDetailsReq,
  GetRepeatDetailsRsp,
  GetTurntableActivityBonusRecsReq,
  GetTurntableActivityBonusRecsResp,
  GetUserRankDetailsReq,
  GetUserRankDetailsRsp,
  GetUserRankHistoryReq,
  GetUserRankHistoryRsp,
  GetUserRepeatRankHistoryReq,
  GetUserRepeatRankHistoryRsp,
  UserRepeatRankDetails,
} from "@/types/swagger/activity";
import {
  ManualExchangeBonusReq,
  ManualExchangeBonusResp,
} from "@/types/swagger/appserver";
import {
  GetActivityConfigReq,
  GetSpecialRewardsResp,
  MyBonusTotalResp,
  MyBonusTransactionReq,
  MyBonusTransactionResp,
  ReceiveRewardReq,
  ReceiveRewardVipLevelUpReq,
  ReceiveRewardVipLevelUpRsp,
  UseGiftCodeReq,
  UseGiftCodeResp,
} from "@/types/swagger/front";
import {
  GetFreeUserPromoItemListReq,
  GetFreeUserPromoItemListResp,
  GetUserPromoItemListReq,
  GetUserPromoItemListResp,
  UseUserPromoItemReq,
  UseUserPromoItemResp,
} from "@/types/swagger/promoItem";
import {
  ReceiveRewardRsp,
  ReceiveRewardsReq,
  ReceiveRewardsRsp,
} from "@/types/swagger/reward";
import {
  GetActivityConfigRsp,
  GetActivityStatusRspMap,
  GetOffLineActivityConfigRsp,
  NewActivityDetails,
} from "@/types/swaggerex/activity";
import {
  GetStreamerBetRankInfo,
  GetStreamerBetRankReq,
  GetStreamerBetRankRsp,
} from "@/types/whRank";

export const postGetActivityDetails = (
  data: GetDetailsV2Req,
  update: boolean = true,
) => {
  return reqPost<GetDetailsV2Req, GetDetailsV2Rsp>(
    data,
    NetActivity.mod,
    NetActivity.GetDetailsV2,
    true,
    undefined,
    undefined,
    undefined,
    (res) => {
      if (update) {
        const keys = Object.keys(res.activity_details);
        if (keys.length > 0) {
          keys.forEach((key) => {
            updateDetailsData(
              Number(key),
              res.activity_details[key] as NewActivityDetails,
            );
          });
        } else {
          data.atypes.forEach((key) => {
            updateDetailsData(Number(key), {} as NewActivityDetails);
          });
        }
      }
    },
  );
};

export const postGetBonusSummaryData = () => {
  return reqPost<{}, MyBonusTotalResp>(
    {},
    NetFront.mod,
    NetFront.MyBonusTotal,
    true,
  );
};

export const postGetActivityConfig = (aType: number) => {
  const param: GetActivityConfigReq = {
    channel: "-1",
    general: "-1",
    skip_rules: "0",
    atypes: aType + "",
    labels: "",
  };
  return reqPost<GetActivityConfigReq, GetActivityConfigRsp>(
    param,
    NetFront.mod,
    NetFront.GetActivityConfig,
    false,
  );
};

export const postDoActive = (data: ActivityReq) => {
  return reqPost<ActivityReq, ActiveRsp>(
    data,
    NetActivity.mod,
    NetActivity.DoActive,
    true,
  );
};

export const postGetMyBonusTransaction = (data: MyBonusTransactionReq) => {
  return reqPost<MyBonusTransactionReq, MyBonusTransactionResp>(
    data,
    NetFront.mod,
    NetFront.MyBonusTransaction,
    true,
  );
};
// 免费投注道具列表
export const postGetFreeUserPromoItemList = (
  data: GetFreeUserPromoItemListReq,
) => {
  return reqPost<GetFreeUserPromoItemListReq, GetFreeUserPromoItemListResp>(
    data,
    NetPromoItem.mod,
    NetPromoItem.GetFreeUserPromoItemList,
    true,
  );
};
// 道具列表
export const postGetUserPromoItemList = (data: GetUserPromoItemListReq) => {
  return reqPost<GetUserPromoItemListReq, GetUserPromoItemListResp>(
    data,
    NetPromoItem.mod,
    NetPromoItem.GetUserPromoItemList,
    true,
  );
};
// 使用道具
export const useUserPromoItem = (data: UseUserPromoItemReq) => {
  return reqPost<UseUserPromoItemReq, UseUserPromoItemResp>(
    data,
    NetPromoItem.mod,
    NetPromoItem.UseUserPromoItem,
    true,
  );
};

export const postGetSpecialActivityRewards = () => {
  return reqPost<{}, GetSpecialRewardsResp>(
    {},
    NetFront.mod,
    NetFront.GetSpecialActivityRewards,
    true,
  );
};
// 投注比赛
export const useGetUserRankDetails = (data: GetUserRankDetailsReq) => {
  return reqPost<GetUserRankDetailsReq, GetUserRankDetailsRsp>(
    data,
    NetActivity.mod,
    NetActivity.GetUserRankDetails,
  );
};

export const useGetAllAgentConfig = (data: GetAllAgentConfigReq) => {
  return reqPost<GetAllAgentConfigReq, GetAllAgentConfigRsp>(
    data,
    NetActivity.mod,
    NetActivity.GetAllAgentConfig,
    true,
  );
};

export const useGetAgentDetails = (data: GetAgentDetailsReq) => {
  return reqPost<GetAgentDetailsReq, GetAgentDetailsRsp>(
    data,
    NetActivity.mod,
    NetActivity.GetAgentDetails,
    true,
  );
};
// 历史投注比赛
export const getUserRankHistory = (data: GetUserRankHistoryReq) => {
  return reqPost<GetUserRankHistoryReq, GetUserRankHistoryRsp>(
    data,
    NetActivity.mod,
    NetActivity.GetUserRankHistory,
  );
};

// 优惠活动详情
export const getRepeatDetails = (data: GetRepeatDetailsReq) => {
  return reqPost<GetRepeatDetailsReq, GetRepeatDetailsRsp>(
    data,
    NetActivity.mod,
    NetActivity.GetRepeatDetails,
    true,
  );
};

// 优惠活动
export const getAllRepeatConfig = () => {
  return reqPost<{}, GetAllRepeatConfigRsp>(
    {},
    NetActivity.mod,
    NetActivity.GetAllRepeatConfig,
    true,
  );
};

// 优惠活动
export const GetRepeatConfigNoAuth = () => {
  return reqPost<{}, GetAllRepeatConfigRsp>(
    {},
    NetActivity.mod,
    NetActivity.GetRepeatConfigNoAuth,
    true,
  );
};

// 优惠活动包含基础基础配置
export const getAllRepeatConfigContainBasic = () => {
  return reqPost<{}, GetAllRepeatConfigRsp>(
    {},
    NetActivity.mod,
    NetActivity.GetAllRepeatConfigContainBasic,
    true,
  );
};
export const useGetActivityConfig = (data: GetActivityConfigReq) => {
  return reqGet<GetActivityConfigReq, GetActivityConfigRsp>(
    data,
    NetActivity.mod,
    NetActivity.GetActivityConfig,
    false,
  );
};

export const postGetTurntableActivityConfig = (
  data: GetTurntableActivityBonusRecsReq,
) => {
  return reqPost<
    GetTurntableActivityBonusRecsReq,
    GetTurntableActivityBonusRecsResp
  >(data, NetActivity.mod, NetActivity.GetTurntableActivityBonusRecs, false);
};

export const ReceiveReward = (data: ReceiveRewardReq) => {
  return reqPost<ReceiveRewardReq, ReceiveRewardRsp>(
    data,
    NetFront.mod,
    NetFront.ReceiveReward,
    true,
  );
};

export const ReceiveRewards = (data: ReceiveRewardsReq) => {
  return reqPost<ReceiveRewardsReq, ReceiveRewardsRsp>(
    data,
    NetReward.mod,
    NetReward.ReceiveRewards,
    true,
  );
};

export const postDoManualExchangeBonus = (data: ManualExchangeBonusReq) => {
  return reqPost<ManualExchangeBonusReq, ManualExchangeBonusResp>(
    data,
    NetFront.mod,
    NetFront.ManualExchangeBonus,
    true,
  );
};

export const postReceiveVipLevelUpReward = (
  data: ReceiveRewardVipLevelUpReq,
) => {
  return reqPost<ReceiveRewardVipLevelUpReq, ReceiveRewardVipLevelUpRsp>(
    data,
    NetFront.mod,
    NetFront.ReceiveVipLevelUpReward,
    true,
  );
};

export const postUseGiftCode = (data: UseGiftCodeReq) => {
  return reqPost<UseGiftCodeReq, UseGiftCodeResp>(
    data,
    NetFront.mod,
    NetFront.UseGiftCode,
    true,
  );
};
// 获取线下活动
export const getOffLineActivityConfig = (
  needToken: boolean = false,
  atypes: string[] = [],
  skip_rules: boolean = true,
) => {
  return reqPost<{}, GetOffLineActivityConfigRsp>(
    {
      ids: atypes,
      skip_rules: skip_rules,
      need_all_lang: false,
      need_decrypt: true,
    },
    NetFront.mod,
    NetFront.GetOffLineActivityConfig,
    needToken,
  );
};

// 获取活动状态
export const getActivityStatus = () => {
  return reqGet<{}, GetActivityStatusRspMap>(
    {},
    NetActivity.mod,
    NetActivity.GetActivityStatus,
    false,
  );
};

// 获取活动配置
export const getActivityConfig = (atypes: string) => {
  return reqGet<GetActivityConfigReq, GetActivityConfigRsp>(
    {
      channel: "-1",
      general: "-1",
      skip_rules: "1",
      labels: "",
      atypes: atypes,
    },
    NetFront.mod,
    NetFront.GetActivityConfig,
    false,
  );
};

// 客户端版本的getActivityAllConfig
// 客户端版本的getActivityAllConfig
export const clientGetActivityAllConfig = async () => {
  // 先获取活动状态
  const activityStatus = await getActivityStatus();

  // 从活动状态中提取活动类型ID，转换为字符串
  const atypes = Object.keys(activityStatus?.activity_status || {});

  setAllOpenActivity(atypes.map(Number));
  // 使用提取的活动类型ID请求活动配置
  const activityCfg = await getActivityConfig(atypes.join(","));

  return {
    activityStatus,
    activityCfg,
  };
};

interface GetStreamerBetRankResRaw {
  _mod: string;
  _func: string;
  _check: string;
  trace: string;
  _param: GetStreamerBetRankRsp | null;
  my_rank: number;
  list: GetStreamerBetRankInfo[];
}

export const postStreamerRank = (data: GetStreamerBetRankReq) => {
  return reqPost<GetStreamerBetRankReq, GetStreamerBetRankResRaw>(
    data,
    NetActivity.mod,
    "GetStreamerBetRank",
    false,
  );
};

export const postStreamerRankNA = (data: GetStreamerBetRankReq) => {
  return reqPost<GetStreamerBetRankReq, GetStreamerBetRankResRaw>(
    data,
    NetActivity.mod,
    "NA.GetStreamerBetRank",
    false,
  );
};

export const postStreamerRankByFunc = (
  func: string,
  data: GetStreamerBetRankReq,
) => {
  return reqPost<GetStreamerBetRankReq, GetStreamerBetRankRsp>(
    data,
    NetActivity.mod,
    func,
    false,
  );
};

/** GetUserRepeatRankDetailsReq */
export interface GetUserRepeatRankDetailsReq {
  /**
   * 活动id
   *
   * @format int32
   */
  atype: number;
  /** 活动id列表 */
  activity_ids?: string[];
  /**
   * 是否需要排行榜
   *
   * @format boolean
   */
  has_list: boolean;
  /**
   * 时候需要上一局第一名的信息
   *
   * @format boolean
   */
  has_prev: boolean;
  /** @format int64 */
  page: number;
  /** @format int64 */
  page_size: number;
}

/** GetUserRepeatRankDetailsResp */
export interface GetUserRepeatRankDetailsResp {
  list: UserRepeatRankDetails[];
}

/** UserRankInfo */
export interface UserRankInfo {
  /**
   * 排名
   *
   * @format int32
   */
  rank: number;
  /** @format int32 */
  settle_type: number;
  /** @format int32 */
  app_id: number;
  /** @format int64 */
  user_id: number;
  /** @format int32 */
  vip_level: number;
  /** 昵称 */
  nickname: string;
  /** @format int64 */
  bet_point: number;
  /** @format int64 */
  win_point: number;
  /** @format int64 */
  hit_point: number;
  /** @format int64 */
  reward_point: number;
  /** @format int64 */
  reward_rate: number;
  /** @format int32 */
  reward_type: number;
}

/** RepeatRankPrevFirst */
export interface RepeatRankPrevFirst {
  /** @format int32 */
  app_id: number;
  /** @format int64 */
  user_id: number;
  nickname: string;
  avatar: string;
  /** @format int32 */
  reward_type: number;
  /** @format int64 */
  reward_point: number;
  /** @format int64 */
  reward_rate: number;
}

/** RepeatRankRecentJackpot */
export interface RepeatRankRecentJackpot {
  /**
   * 奖池金额
   *
   * @format int64
   */
  jackpot: number;
  /**
   * 日期
   *
   * @format int64
   */
  time_flag: number;
}

export const GetUserRepeatRankDetails = (data: GetUserRepeatRankDetailsReq) => {
  return reqPost<GetUserRepeatRankDetailsReq, GetUserRepeatRankDetailsResp>(
    data,
    NetActivity.mod,
    NetActivity.GetUserRepeatRankDetails,
    false,
  );
};

export const GetUserRepeatRankHistory = (data: GetUserRepeatRankHistoryReq) => {
  return reqPost<GetUserRepeatRankHistoryReq, GetUserRepeatRankHistoryRsp>(
    data,
    NetActivity.mod,
    NetActivity.GetUserRepeatRankHistory,
    false,
  );
};

export const GetRepeatConfigsByAtype = (data: GetRepeatConfigsByAtypeReq) => {
  return reqPost<GetRepeatConfigsByAtypeReq, GetRepeatConfigsByAtypeResp>(
    data,
    NetActivity.mod,
    NetActivity.GetRepeatConfigsByAtype,
    false,
  );
};

export const GetRepeatDetailsByAtype = (data: GetRepeatDetailsByAtypeReq) => {
  return reqPost<GetRepeatDetailsByAtypeReq, GetRepeatDetailsByAtypeRsp>(
    data,
    NetActivity.mod,
    NetActivity.GetRepeatDetailsByAtype,
    true,
  );
};
